export default __webpack_public_path__ + "static/media/icon-software.13c929df.svg";